<div class="calendar-container">
	<full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>

<div class="grid">
	<div class="col-12">
		<div class="card">
			<p-table
				#dt1
				[value]="reservations"
				dataKey="id"
				[rows]="100"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="false"
				sortField="date" 
				[sortOrder]="-1"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<!-- HEADERS -->
					<tr>
						<th class="text-center" pSortableColumn="date">
							<p-sortIcon field="title"></p-sortIcon>
							Fecha - Hora
						</th>
						<th class="text-center" pSortableColumn="user.name" 
						*ngIf="loggedUser.role_id != 4">
							<p-sortIcon field="user.name"></p-sortIcon>
							Cliente
						</th>
						<th class="text-center" pSortableColumn="housing.label">
							<p-sortIcon field="housing.label"></p-sortIcon>
							Dirección
						</th>
						<th class="text-center" pSortableColumn="servicesId">
							<p-sortIcon field="servicesId"></p-sortIcon>
							Servicios - Extras
						</th>
						<th class="text-center" pSortableColumn="transaction.total" *ngIf="loggedUser.role_id != 2">
							<p-sortIcon field="transaction.total"></p-sortIcon>
							Total €
						</th>
						<th>Estado</th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-reservation>
					<tr>
						<td class="text-center" style="min-width: 5rem">
							{{ reservation.date | date: 'dd/MM/yyyy' }} {{ reservation.time }}
						</td>
						<td class="text-left" style="min-width: 5rem" *ngIf="loggedUser.role_id != 4">
							<div class="circle-color circle-color-small" [style.background]="'#'+reservation.user.color"></div>
							{{ reservation.user.name }} {{ reservation.user.surname }}<br><small>{{ reservation.user.email }}</small>
						</td>
						<td class="text-left" style="min-width: 5rem">
							{{ reservation.housing.label }} <br>
							<!-- {{ reservation.type == 1 ? 'Entrada a piso': 'Salida de piso'}} -->
						</td>
						<td class="text-left" style="min-width: 5rem">
							<div class="w-100" *ngIf="loggedUser.role_id != 2">
								Servicio: {{reservation.transaction.total_services}} €<br>
								<label class="label" *ngFor="let service of reservation.services">
									{{servicesData[service.service_id] ? servicesData[service.service_id].name : '' }} - 
									{{ service.price | currency: 'EUR'}} <br>
								</label>
							</div>
							
							<div class="w-100" *ngIf="loggedUser.role_id == 2">
								Servicio:<br>
								<label class="label" *ngFor="let service of reservation.services">
									{{servicesData[service.service_id] ? servicesData[service.service_id].name : '' }}<br>
								</label>
							</div>

							<div class="w-100" *ngIf="reservation.extras.length > 0 && loggedUser.role_id != 2">
								<br>
								Extras: {{reservation.transaction.total_extras}} €<br>
								<label class="label" *ngFor="let extra of reservation.extras">
									{{extrasData[extra.extra_id] ? extrasData[extra.extra_id].name : '' }} - 
									{{extra.price | currency: 'EUR' }} <br>
								</label>
							</div>
							
							<div class="w-100" *ngIf="reservation.extras.length > 0 && loggedUser.role_id == 2">
								<br>
								Extras:<br>
								<label class="label" *ngFor="let extra of reservation.extras">
									{{extrasData[extra.extra_id] ? extrasData[extra.extra_id].name : '' }}<br>
								</label>
							</div>

						</td>
						<td class="text-left" style="min-width: 5rem" *ngIf="loggedUser.role_id != 2">
							<div class="w-100 fw-bold" [ngClass]="reservation.status === 2?'text-success':reservation.status === 0?'text-danger':''">
								{{reservation.transaction.total}} €
							</div>
						</td>
						<td>
							<button
							   *ngIf="reservation.status === 1 && loggedUser.role_id != 4"
								pButton
								pRipple
								type="button"
								pTooltip="Completada"
								icon="pi pi-check"
								class="p-button-raised p-button m-1 p-button-success"
								(click)="updateReservation(reservation,2)"
							></button>
							
							<button
							   *ngIf="reservation.status === 1 && loggedUser.role_id != 4"
								pButton
								pRipple
								type="button"
								pTooltip="No completada"
								icon="pi pi-times"
								class="p-button-raised p-button m-1 p-button-danger"
								(click)="updateReservation(reservation,0)"
							></button>

							<p-badge *ngIf="reservation.status === 2" value="Completada" severity="success" />
							<p-badge *ngIf="reservation.status === 0" value="No completada" severity="danger" />
							
							<p-badge *ngIf="reservation.status === 1 && loggedUser.role_id == 4" value="A la espera" severity="warning" />


						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-dialog
	[header]="loggedUser.role_id == 4 ? 'Detalle de reserva del día '+ selectedDate : selectedEvent ? 'Editar reserva del día ' + selectedDate  : 'Añadir reserva para el día ' + selectedDate "
	[style]="{ width: '65vw' }"
	[(visible)]="isDialogVisible"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	(onHide)="resetForm()"
>
	<form [formGroup]="form" class="flex flex-column mt-3">
		<div class="flex flex-wrap gap-2 mb-3 d-none">
			<div class="flex align-items-center">
				<p-radioButton 
					value="1" 
					formControlName="type"
					inputId="type1" />
				<label for="type1" class="ml-2">
					Entrada a piso
				</label>
			</div>
			
			<div class="flex align-items-center">
				<p-radioButton 
					value="2" 
					formControlName="type"
					inputId="type2" />
				<label for="type2" class="ml-2">
					Salida de piso
				</label>
			</div>
		</div>
		<div class="flex flex-column gap-2 field" *ngIf="loggedUser.role_id != 4">
			<label for="services">Cliente</label>
			<p-dropdown
				[style]="{ width: '100%' }"
				placeholder="Seleccione cliente"
				optionLabel="label"
				optionValue="value"
				formControlName="user_id"
				appendTo="body"
				[options]="users"
				(onChange)="selectedUser($event)"
			>
			</p-dropdown>
			<small class="p-error"
			*ngIf="
					form.get('user_id')!.errors &&
					form.get('user_id')!.touched &&
					form.get('user_id')!.hasError('required')
				"
			>Requerido</small>
		</div>
		
		<div class="flex flex-column gap-2 field">
			<label for="services">Vivienda</label>
			<p-dropdown
				[style]="{ width: '100%' }"
				placeholder="Seleccione vivienda"
				optionLabel="label"
				optionValue="value"
				formControlName="housing_id"
				appendTo="body"
				[options]="housings"
				(onChange)="selectHousing($event)"
			>
			</p-dropdown>
			<small class="p-error"
			*ngIf="
					form.get('housing_id')!.errors &&
					form.get('housing_id')!.touched &&
					form.get('housing_id')!.hasError('required')
				"
			>Requerido</small>
		</div>

		<div class="grid">
			<div class="sm:col-12 md:col-6">
				<div class="flex flex-column gap-2 field" *ngIf="deleteEnable">
					<label for="services">Servicios</label>
					<div class="grid">
						<div class="col-10">
							<p-dropdown
							[style]="{ width: '100%' }"
								placeholder="Seleccione un servicio"
								optionLabel="label"
								optionValue="value"
								formControlName="service"
								appendTo="body"
								[options]="services"
								trackBy="label"
								(onChange)="loadPrices()"
							>
							</p-dropdown>
						</div>
						<div class="col-2">
							<button pButton icon="pi pi-plus" class="ml-2" (click)="addService()"></button>
						</div>
					</div>
		
					<small class="p-error"
					*ngIf="
							form.get('service')!.errors &&
							form.get('service')!.touched &&
							form.get('service')!.hasError('required')
						"
					>Requerido</small>
				</div>
			</div>
			<div class="sm:col-12 md:col-6">
				<div class="flex flex-column gap-2 field" *ngIf="deleteEnable">
					<label for="services">Extras</label>
					<div class="grid">
						<div class="col-10">
							<p-dropdown
							[style]="{ width: '100%' }"
								placeholder="Seleccione un extra si lo requiere"
								optionLabel="label"
								optionValue="value"
								formControlName="extra"
								appendTo="body"
								[options]="extras"
								(onChange)="loadPrices()"
							>
							</p-dropdown>
						</div>
						<div class="col-2">
							<button pButton icon="pi pi-plus" class="ml-2" (click)="addExtra()"></button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid">
			<div class="col-4">
				<div class="flex flex-column gap-2 field">
					<label>Hora</label>
					<p-calendar
					    dateFormat="HH:mm"
						[timeOnly]="true"
						formControlName="time"
						placeholder="HH:mm"
						appendTo="body"
					></p-calendar>
					<small class="p-error"
					*ngIf="
							form.get('time')!.errors &&
							form.get('time')!.touched &&
							form.get('time')!.hasError('required')
						"
					>Requerido</small>
				</div>
			</div>
		</div>
		<div class="grid">
			<div class="col-6" *ngIf="servicesList.length > 0">
				<h4 class="mt-4">Servicios Añadidos:</h4>
				<ol>
				  <li *ngFor="let service of servicesList; let i = index">
					<i class="pi pi-trash" style="font-size: 1.2rem;margin-right:5px;" *ngIf="deleteEnable" (click)="deleteService(i)"></i>
					{{ service.name }} <span *ngIf="loggedUser.role_id != 2">{{ service.price | currency: 'EUR' }}</span>
				  </li>
				</ol>
			</div>
			<div class="col-6" *ngIf="extrasList.length > 0">
				<h4 class="mt-4">Extras Añadidos:</h4>
				<ol>
				  <li *ngFor="let extra of extrasList; let i = index">
					<i class="pi pi-trash" style="font-size: 1.2rem;margin-right:5px;" *ngIf="deleteEnable" (click)="deleteExtra(i)"></i>
					{{ extra.name }} <span *ngIf="loggedUser.role_id != 2">{{ extra.price | currency: 'EUR' }}</span>
				  </li>
				</ol>
			</div>
			<div class="col-12" *ngIf="total">
				<div class="flex flex-column gap-2 field text-right">
					<h4 class="mt-4">Total a pagar es: {{total}}€</h4>
				</div>
			</div>
		</div>
	</form>
	<ng-template pTemplate="footer">
		<div class="flex justify-content-end col-12">
			<p-button
				*ngIf="selectedEvent && !loading && deleteEnable"
				styleClass="p-button-danger"
				label="Eliminar"
				(click)="showDeletingForm(selectedEvent?.reservation_id)"
			>
			</p-button>
			<div *ngIf="loading" class="text-center">
				<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
			</div>

			<p-button
			    *ngIf="!loading && deleteEnable"
				styleClass="p-button-rounded"
				[label]="selectedEvent ? 'Guardar' : 'Guardar'"
				(click)="saveReserve()"
			>
			</p-button>
		</div>
	</ng-template>
</p-dialog>